<div class="wo-details-box-primary" *ngIf="primaryDefined">{{ primary }}<ng-content/></div>
<div class="wo-details-box-secondary" *ngIf="secondaryDefined">{{ secondary }}</div>
